export enum TooltipVariant {
  Primary,
  Secondary,
  Dark,
}
